import * as React from 'react'
import * as ReactRedux from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { nanoid } from 'nanoid'

import * as Herz from '@rushplay/herz'

import * as Configuration from './configuration'

export function generateSessionId() {
  const timestamp = Date.now()
  const id = nanoid()
  return `HG.${timestamp}.${id}`
}

// This wrapper enables SEON
export function SeonProvider(props) {
  const isSeonEnabled = ReactRedux.useSelector(state =>
    Configuration.isSeonEnabled(state)
  )

  return (
    <Herz.Seon.FingerprintProvider
      {...props}
      disabled={!process.browser || !isSeonEnabled}
      renderScript={props => (
        <Helmet>
          <script {...props} />
        </Helmet>
      )}
    />
  )
}
